import { render } from "./FormSection.vue?vue&type=template&id=da2ef1be&ts=true"
import script from "./FormSection.vue?vue&type=script&lang=ts"
export * from "./FormSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__